import React from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'

import AnalyticsTable from './Components/AnalyticsTable'
import AnalyticsAbout from './Components/AnalyticsAbout'

function Analytics({ tiersData }) {
  return (
    <div className="row">
      {tiersData && tiersData.data.user.sellerAnalyticsParticipant && tiersData.data.user.currentTier > 0 ? (
        <div className="col-12">
          <div className="card card--flat dashboard-card--analytics">
            <div className="dashboard-card">
              <h3>
                <a href="/profile/analytics">Top keywords</a> <Tooltip
                  tooltipClassName="tooltip--medium"
                  id="dashboard__analytics-info"
                  content="Analytics is a set of extensive real-time insights into the marketplace. Click 'Show more' to
              see the demand, competition, pricing and other valuable data for hundreds of keywords on CGTrader."
                >
                  <Icon type={['far', 'question-circle']} color="grey" notSpaced />
                                                              </Tooltip>
              </h3>

              <AnalyticsTable tiersData={tiersData} />
            </div>
          </div>

          <div className="card card--flat">
            <a href="/profile/analytics" className="btn btn-transparent btn-block btn-show-more">Show more</a>
          </div>
        </div>
      ) : (
        <div className="col-12">
          <div className="card card--flat dashboard-card--analytics">
            <AnalyticsAbout participant={tiersData ? tiersData.data.user.sellerAnalyticsParticipant : false} />
          </div>
        </div>
      )}
    </div>
  )
}

Analytics.propTypes = {
  tiersData: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
}

Analytics.defaultPropTypes = {
  tiersData: {},
}

export default Analytics
